import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { testId } from 'ui-components/services/testid-service';

import { DEFAULTS } from '../../ship-from/components/ship-from-dropdown/constants';
import { useSortedStrings } from '../../hooks/use-sorted-translations';
import { ValidationPropType } from '../../ship-from/components/ship-from-dropdown/prop-types';
import messages from '../messages';

const sortOptions = {
  labelProp: 'name',
};

const ShipFromDropdown = ({ id, dropdownMenuType, onChange, selectedShipFromId, shipFroms, validation = DEFAULTS.validation }) => {
  const { helperText, helperTextType } = validation;
  const intl = useIntl();
  const [text, setText] = useState('');

  useEffect(() => {
    const selectedShipFrom = shipFroms.find(({ id: shipFromId }) => shipFromId === selectedShipFromId);
    setText(selectedShipFrom?.name ?? (selectedShipFromId ? intl.formatMessage(messages.customAddress) : undefined));
  }, [selectedShipFromId, shipFroms, intl]);

  const shipFromsSorted = useSortedStrings(shipFroms, sortOptions);

  return (
    <div>
      <DropdownMenu
        {...testId('csw-ship-from')}
        aria-label={intl.formatMessage(messages.shipFrom)}
        dropdownMenuShouldHaveWidthOfButton
        dropdownMenuType={dropdownMenuType}
        fullWidth
        id={id}
        inlineMessage={helperText}
        inlineMessageType={helperTextType}
        value={selectedShipFromId}
        variant='form'
      >
        <DropdownMenuToggler>{text}</DropdownMenuToggler>
        {shipFromsSorted.map(({ id: shipFromId, name }) => (
          <DropdownMenuItem key={shipFromId} name={shipFromId} onClick={onChange} selected={selectedShipFromId === shipFromId}>
            {name}
          </DropdownMenuItem>
        ))}
      </DropdownMenu>
    </div>
  );
};

ShipFromDropdown.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  onChange: PropTypes.func.isRequired,
  selectedShipFromId: PropTypes.string,
  shipFroms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  validation: ValidationPropType,
};

export default ShipFromDropdown;
